export const gift = [
  {
    text: "Gift",
    lists: {
      title: "Gifts",
      Sidebar: [
        "Beauty Gifts",
        "Cozy Shop",
        "Designer Handbags",
        "Eco Friendly",
        "Fine Jewelry",
        "For the Trend Setter",
        "Gift Cards",
        "Gifts with a Purpose",
        "Intimates",
      ],
      alldata: [
        {
          heading: "All Gifts",
          child: [
            "Gifts for Her",
            "Gifts for Him",
            "Gifts for Kids",
            "Gifts for Pets",
            "Gifts for the Home",
            "Gift Cards",
            "Shop All...",
          ],
        },
        {
          heading: "Gifts by Price",
          child: [
            "Under $ 10",
            "Under $ 25",
            "Under $ 50",
            "Under $ 100",
            "Over $ 100",
            "Gift Cards",
            "Shop All...",
          ],
        },
        {
          heading: "Gifts by Recipient",
          child: [
            "For the Foodie",
            "For the Hostess",
            "For the Outdoorsman",
            "For the Sports Fan",
            "For the Techie",
            "Gift Cards",
            "Show All...",
          ],
        },
        {
          heading: "Just for Kids",
          child: [
            "Active Gear",
            "Kids Fan Gear",
            "Toys & Games",
            "Gift Cards",
            "Shop All...",
          ],
        },
        {
          heading: "Favorite Brands",
          child: [
            "Brahmin",
            "Estee Lauder",
            "Free People",
            "Michael Kors",
            "Relph Lauren",
            "Shop All...",
          ],
        },
      ],
    },
  },
  {
    text: "Women",
    lists: {
      title: "Women",
      Sidebar: [
        "New Arrivals",
        "Active Shop",
        "Contemporary",
        "Cozy Shop",
        "The Culture Shop",
        "Denim Shop",
        "Designer",
        "Fan Gear",
        "Gifts for Her",
        "Pajamas & Robes",
        "Women`s Clearance",
        "Gift Cards",
      ],
      alldata: [
        {
          heading: "Clothing",
          child: [
            "Bras, Panties & Lingerie",
            "Coats & Outerwear",
            "Dresses",
            "Pants & Leggings",
            "Sweaters",
            "Shop All...",
          ],
        },
        {
          heading: "Plus Size Clothing",
          child: [
            "Bras, Panties & Lingerie",
            "Dresses",
            "Jeans",
            "Pants",
            "Tops",
            "Shop All...",
          ],
        },
        {
          heading: "Footwear",
          child: [
            "Ballerinas",
            "Casual Shoes",
            "Flats",
            "Heels",
            "Slippers & Flip Flops",
            "Sports Sandals",
            "Sports Shoes",
          ],
        },
        {
          heading: "Women`s Tops",
          child: [
            "Blouses",
            "Button Down Tops",
            "Hoodies & Sweatshirts",
            "Tunices",
            "T-Shirts",
            "Shop All...",
          ],
        },
        {
          heading: "Junior`s Clothing",
          child: [
            "Activewear",
            "Dresses",
            "Jeans",
            "Junior`s Plus",
            "Tops",
            "Shop All...",
          ],
        },
        {
          heading: "Women`s Dresses",
          child: [
            "Casual",
            "Cocktail & Party",
            "Formal",
            "Maxi",
            "Work",
            "Shop All...",
          ],
        },
      ],
    },
  },
  {
    text: "Men",
    lists: {
      title: "Men",
      Sidebar: [
        "New Arrivals",
        "Active Shop",
        "The Culture Shop",
        "Designer",
        "Fan Gear",
        "Formal Wear & Wedding",
        "Gifts for Him",
        "Golf Shop",
        "Men`s Clearance",
        "Gift Cards",
      ],
      alldata: [
        {
          heading: "Clothing",
          child: [
            "Accessories & Combo Sets",
            "Cargos, Shorts & 3/4ths",
            "Ethnic Wear",
            "Fabrics",
            "Inner Wear & Sleep Wear",
            "Jeans",
            "Shirts",
            "Sports Wear",
            "Suits & Blazers",
            "T-Shirts",
            "Trousers",
            "Winter & Seasonal Wear",
          ],
        },
        {
          heading: "Big & Tall Clothing",
          child: [
            "Active & Outdoor",
            "Pants",
            "Polos",
            "Shirts",
            "Suits & Sport Coats",
            "Shop All...",
          ],
        },
        {
          heading: "Young Men's Clothing",
          child: [
            "Active & Outdoor",
            "Graphic Tees",
            "Hoodies & Sweatshirts",
            "Jeans",
            "Shirts",
            "Show All...",
          ],
        },
        {
          heading: "Footwear",
          child: [
            "Casual Shoes",
            "Formal Shoes",
            "Sandals & Floaters",
            "Slippers & Flip Flops",
            "Sports Shoes",
          ],
        },
        {
          heading: "Beauty and Personal Care",
          child: [
            "Sivanna Men's Grooming",
            "Gifts & Gadgets",
            "Hats",
            "Ties & Pocket Squares",
            "Wallets & Money Clips",
            "Shop All...",
          ],
        },
        {
          heading: "Men's Jewelry & Watches",
          child: [
            "Bracelets",
            "Jewelry Sets",
            "Necklaces",
            "Rings",
            "Watches",
            "Shop All...",
          ],
        },
      ],
    },
  },
  {
    text: "Kids",
    lists: {
      title: "Kids",
      Sidebar: [
        "New Arrivals",
        "Baby Essentials",
        "Birthday & Holidays",
        "Character Shop",
        "Dresswear",
        "Gifts for Kids",
        "Kid`s Shoes",
        "Toys & Games",
        "Baby & Kids Clearance",
        "Gift Cards",
      ],
      alldata: [
        {
          heading: "Clothing",
          child: [
            "Boys Wear",
            "Infants Wear",
            "Girls Wear",
            "Shirts",
            "Suits & Dresswear",
            "Shop All...",
          ],
        },
        {
          heading: "Girl's Clothing",
          child: [
            "Activewear",
            "Dresses & Skirts",
            "Jeans",
            "Sets & Outfits",
            "Tops",
            "Shop All...",
          ],
        },
        {
          heading: "Baby Care",
          child: ["Decorations", "Stickers"],
        },
        {
          heading: "Footwear",
          child: [
            "For Boys",
            "For Girls",
            "Jeans",
            "Plus Size",
            "Tops",
            "Shop All...",
          ],
        },
        {
          heading: "Shops by Size",
          child: [
            "Boys' (8-20)",
            "Girls' (7-16)",
            "Boys' (4-7)",
            "Girls' (4-6x)",
            "Baby",
            "Shop All...",
          ],
        },
        {
          heading: "Kids' Brands",
          child: [
            "Adidas",
            "Carter's",
            "Levi's",
            "Nike",
            "Ralph Lauren",
            "Childrenswear",
            "Shop All...",
          ],
        },
        {
          heading: "Furniture",
          child: ["Kids Tables & Seating"],
        },
      ],
    },
  },

  {
    text: "Shoes",
    lists: {
      title: "Shoes",
      Sidebar: [
        "New Arrivals",
        "Extra Wide",
        "Gift Shop",
        "Narrow",
        "Shoe Accessories",
        "Sizes 11+",
        "Special Occasion",
        "Wide",
        "Shoe Clearance",
        "Gift Cards",
      ],
      alldata: [
        {
          heading: "Women's Shoes",
          child: [
            "Boots",
            "Comfort",
            "Designer",
            "Heels & Pumps",
            "Sneakers",
            "Shop All...",
          ],
        },
        {
          heading: "Men's Shoes",
          child: [
            "Boots",
            "Casual Shoes",
            "Designer",
            "Dress Shoes",
            "Sneakers",
            "Shop All...",
          ],
        },
        {
          heading: "Junior's Shoes",
          child: [
            "Boots",
            "Flats",
            "Heels & Pumps",
            "Sneakers",
            "Wedgets",
            "Show All...",
          ],
        },
        {
          heading: "Kid's Shoes",
          child: [
            "Boys' Shoes",
            "Girls' Shoes",
            "Baby (Sizes 1-4)",
            "Boys' Sneakers",
            "Girls' Sneakers",
            "Shop All...",
          ],
        },
        {
          heading: "Shoes Brands",
          child: [
            "Free People",
            "MICHAEL Michael Kors",
            "Sam Edelman",
            "Skechers",
            "Steve Madden",
            "Shop All...",
          ],
        },
      ],
    },
  },
  {
    text: "Handbags",
    lists: {
      title: "Handbags",
      Sidebar: [
        "New Arrivals",
        "The Culture Shop",
        "Designer",
        "Gift Shop",
        "Small Accessories",
        "Stationary & Gifts",
        "Sunnies Sunglasses Shop",
        "Winter Accessories",
        "Handbag Clearance",
        "Gift Cards",
      ],
      alldata: [
        {
          heading: "Purses & Handbags",
          child: [
            "Crossbody Bags",
            "Designer",
            "Satchels",
            "Shoulder Bags",
            "Totes",
            "Shop All...",
          ],
        },
        {
          heading: "Women's Accessories",
          child: [
            "Belts",
            "Hats",
            "Scarves & Wraps",
            "Sunglasses",
            "Wallets",
            "Shop All...",
          ],
        },
        {
          heading: "Vintage Handbags",
          child: [
            "Chanel",
            "Chloe",
            "Gucci",
            "Louis Vuitton",
            "Prada",
            "Show All...",
          ],
        },
        {
          heading: "Travel & Luggage",
          child: [
            "Carry-On-Luggage",
            "Checked Luggage",
            "Luggage Sets",
            "Spinners",
            "Hardside",
            "Shop All...",
          ],
        },
        {
          heading: "Handbag Brands",
          child: [
            "Brahmin",
            "COACH",
            "Dooney & Bourke",
            "Lauren Ralph Lauren",
            "MICHAEL Michael Kors",
            "Shop All...",
          ],
        },
        {
          heading: "Sunnies Sunglasses Shop",
          child: [
            "Burbarry",
            "Gucci",
            "Oakley",
            "Ray-Ban",
            "Versace",
            "Shop All...",
          ],
        },
      ],
    },
  },
  {
    text: "Jewelry",
    lists: {
      title: "Jewelry",
      Sidebar: [
        "New Arrivals",
        "The Culture Shop",
        "Diamond Guide",
        "Gift Shop",
        "Personalized Jewelry",
        "Sterling Silver",
        "Jewelry Clearance",
        "Gift Cards",
      ],
      alldata: [
        {
          heading: "Fine Jewelry",
          child: [
            "Birthstones",
            "Bracelets",
            "Earrings",
            "Necklaces",
            "Rings",
            "Shop All...",
          ],
        },
        {
          heading: "Fashion Jewelry",
          child: [
            "Anniversary",
            "Bridal Sets",
            "Diamond Guide",
            "Engagement",
            "Wedding Bands",
            "Shop All...",
          ],
        },
        {
          heading: "Watches",
          child: [
            "Designer Watches",
            "Fitness Trackers",
            "Luxury Watches",
            "Men's Watches",
            "Women's Watches",
            "Show All...",
          ],
        },
        {
          heading: "Men's Jewelry",
          child: [
            "Bracelets",
            "Cufflinks & Tie Bars",
            "Jewelry Sets",
            "Neckleces",
            "Rings",
            "Shop All...",
          ],
        },
        {
          heading: "Jewelry Brands",
          child: [
            "LINT & Co",
            " LINT Silverworks",
            " Effy",
            "Lauren Ralph Lauren",
            "Le Vian",
            "Shop All...",
          ],
        },
      ],
    },
  },
  {
    text: "Beauty",
    lists: {
      title: "Beauty",
      Sidebar: [
        "New Arrivals",
        "Bath & Body",
        "Beauty Gifts & Sets",
        "Clean Beauty",
        "The Culture Shop",
        " Free Gift with Purchase",
        "Gift Shop",
        "Inclusive Beauty",
        "Subscription Eligible",
        "Beauty Clearance",
        "Gift Cards",
      ],
      alldata: [
        {
          heading: "Makeup",
          child: [
            "Eye Makeup",
            "Face Makeup",
            "Lip Makeup",
            "Masvara",
            "Palettes & Sets",
            "Shop All...",
          ],
        },
        {
          heading: "Fragrances",
          child: [
            "Candles & Diffusers",
            "Deodorants",
            "Fragrance Gifts & Sets",
            "Men's Cologne",
            "Women's Perfumes",
            "Shop All...",
          ],
        },
        {
          heading: "Skin Care",
          child: [
            "Cleansers",
            "Gift & Value Sets",
            "Masks",
            "Moisturizers",
            "Treatments & Serums",
            "Show All...",
          ],
        },
        {
          heading: "Men's Grooming & Cologue",
          child: [
            "Gift & Value Sets",
            "Hair & Body Care",
            "Men's Cologne",
            "Shaving",
            "Skin Care",
            "Shop All...",
          ],
        },
        {
          heading: "Hair Care & Tools",
          child: [
            "Curling Irons & Hair Rollers",
            "Hair Dryers",
            "Hair Straighteners",
            "Shampoos & Conditioners",
            "Styling Products",
            "Shop All...",
          ],
        },
        {
          heading: "Beauty Brands",
          child: [
            "Benefit Cosmetics",
            "Bobbi Brown",
            "Clinique",
            "Estee Lauder",
            "MAC",
            "Shop All...",
          ],
        },
      ],
    },
  },
  {
    text: "Home",
    lists: {
      title: "Home",
      Sidebar: [
        "New Arrivals",
        "Conns LINT",
        "Electronics",
        "Health & Wellness",
        "Organization & Cleaning",
        "Rugs",
        "Toys & Games",
        "Window Treatments",
        "Home Clearance",
        "Gift Cards",
      ],
      alldata: [
        {
          heading: "Home & Kitchen",
          child: [
            "Refrigerators",
            "Voltage Stabilizers",
            "Cookware",
            "Food Storage",
            "Utensils & Gadgets",
            "Shop All...",
          ],
        },
        {
          heading: " Home Improvement",
          child: [
            "Laundry",
            "Decorative Accents",
            "Lamps & Lighting",
            "Throws & Throw Pillows",
            "Wall Art & Decor",
            "Shop All...",
          ],
        },
        {
          heading: "Kitchen & Dining",
          child: [
            "Mosquito Killers",
            "Drinkware",
            "Silverware & Flatware",
            "Serveware",
            "Table Linens",
            "Show All...",
          ],
        },
        {
          heading: "Travel & Luggage",
          child: [
            "Carry-On Luggage",
            "Checked Luggage",
            "Duffle & Weekender Bags",
            "Hardside Luggage",
            "Luggage Sets",
            "Shop All...",
          ],
        },
        {
          heading: "Household Supplies",
          child: [
            "Kitchen Surface Cleaners",
            "Home Office",
            "Kitchen & Dining Room",
            "Living Room",
            "Outdoor & Patio",
            "Shop All...",
          ],
        },
        {
          heading: "Home Entertainment",
          child: ["Speakers"],
        },
      ],
    },
  },
  {
    text: "Bed",
    lists: {
      title: "Bed & Bath",
      Sidebar: [
        "New Arrivals",
        "Furniture",
        "Window Treatments",
        "Bed & Bath Clearance",
        "Gift Cards",
      ],
      alldata: [
        {
          heading: "Home Furnishing",
          child: [
            "Bedsheets",
            "Blankets, Quilts & Dohars",
            "Comforters",
            "Quilts & Coverlets",
            "Sheets",
            "Shop All...",
          ],
        },
        {
          heading: "Baby Care",
          child: [
            "Baby Bedsheets",
            "Baby Blankets",
            "Baby Mosquito Nets",
            "Pillowcases & Protectors",
            "Sheets",
            "Shop All...",
          ],
        },
        {
          heading: "Bath",
          child: [
            "Bathroom Accessories",
            "Bath Rugs & Mats",
            "Bath Towels",
            "Beach Towels",
            "Shower Curtains",
            "Show All...",
          ],
        },
        {
          heading: "Health & Wellness",
          child: [
            "Air Purifiers & Sanitizing",
            "Dental Care",
            "Digital Scales",
            "Humdifiers & Diffusers",
            "Massagers & Foot Spas",
            "Shop All...",
          ],
        },
        {
          heading: "Furniture",
          child: [
            "Beds",
            "Dressing Tables",
            "Madison Park",
            "Modern. Southern Home",
            "Waverly",
            "Shop All...",
          ],
        },
        {
          heading: "Holiday",
          child: [
            "Valentine's Day",
            "Easter",
            "Mother's Day",
            "Father's Day",
            "Fourth of July",
            "Shop All...",
          ],
        },
      ],
    },
  },

  {
    text: "Conn's x LINT",
    lists: {
      title: "Conn's x LINT",
      Sidebar: [
        "Appliances",
        "Decor",
        "Electronic",
        "Furniture",
        "Mattresses & Bedding",
      ],
      alldata: [
        {
          heading: "Appliances",
          child: [
            "Major Appliances",
            "Small Appliances",
            "Vacuums",
            "Shop All...",
          ],
        },
        {
          heading: "Decor",
          child: [
            "Lamps & Lighting",
            "Rugs",
            "Wall Art & Decor",
            "Shop All...",
          ],
        },
        {
          heading: "Electronics",
          child: [
            "Computers & Accessories",
            "Gaming & Toys",
            "Home Electronics",
            "Smart Home",
            "Show All...",
          ],
        },
        {
          heading: "Furniture",
          child: [
            "Bathroom",
            "Bedroom",
            "Home Office",
            "Kitchen & Dining Room",
            "Living Room",
            "Shop All...",
          ],
        },
        {
          heading: "Mattresses Bedding",
          child: ["Bedding", "Mattresses Box Springs & Frames", "Shop All..."],
        },
      ],
    },
  },
  {
    text: "Brands",
    lists: {
      title: "Brands",
      Sidebar: [
        "Active Brands",
        "LINT Exclusives",
        "Jewelry Brands",
        "Kids Brands",
        "Shoe Brands",
      ],
      alldata: [
        {
          heading: "Designer Brands",
          child: [
            "Brahmin",
            "COACH",
            "Free People",
            "MICHAEL Michael Kors",
            "Ralph Lauren",
            "Shop All...",
          ],
        },
        {
          heading: "LINT Exclusives",
          child: [
            "LINT & Co",
            "Biltmore",
            "Crown & Ivy",
            "THE LIMITED",
            "Wonderly",
            "Shop All...",
          ],
        },
        {
          heading: "Women's Brands",
          child: [
            "Crown & Ivy",
            "Lauren Ralph Lauren",
            "MICHAEL Michael Kors",
            "THE LIMITED",
            "Wonderly",
            "Show All...",
          ],
        },
        {
          heading: "Men's Brands",
          child: [
            "Columbia",
            "Crown & Ivy",
            "IZOD",
            "Levi's",
            "Polo Raph Lauren",
            "Shop All...",
          ],
        },
        {
          heading: "Beauty Brands",
          child: [
            "Bobbi Brown",
            "Clinique",
            "Elizabeth Arden",
            "Estee Lauder",
            "MAC",
            "Shop All...",
          ],
        },
        {
          heading: "Home Brands",
          child: [
            "Biltmore",
            "Lauren Ralph Lauren",
            "Modern Southern Home",
            "SOLITE",
            "Shop All...",
          ],
        },
      ],
    },
  },
  {
    text: "Clearance",
    lists: {
      title: "Clearance",
      Sidebar: [
        "Beauty Gifts",
        "Cozy Shop",
        "Designer Handbags",
        "Eco Friendly",
        "Fine Jewelry",
        "For the Trend Setter",
        "Gift Cards",
        "Gifts with a Purpose",
        "Intimates",
      ],
      alldata: [
        {
          heading: "All Gifts",
          child: [
            "Gifts for Her",
            "Gifts for Him",
            "Gifts for Kids",
            "Gifts for Pets",
            "Gifts for the Home",
            "Gift Cards",
            "Shop All...",
          ],
        },
        {
          heading: "Gifts by Price",
          child: [
            "Under $ 10",
            "Under $ 25",
            "Under $ 50",
            "Under $ 100",
            "Over $ 100",
            "Gift Cards",
            "Shop All...",
          ],
        },
        {
          heading: "Gifts by Recipient",
          child: [
            "For the Foodie",
            "For the Hostess",
            "For the Outdoorsman",
            "For the Sports Fan",
            "For the Techie",
            "Gift Cards",
            "Show All...",
          ],
        },
        {
          heading: "Just for Kids",
          child: [
            "Active Gear",
            "Kids Fan Gear",
            "Toys & Games",
            "Gift Cards",
            "Shop All...",
          ],
        },
        {
          heading: "Favorite Brands",
          child: [
            "Brahmin",
            "Estee Lauder",
            "Free People",
            "Michael Kors",
            "Relph Lauren",
            "Shop All...",
          ],
        },
      ],
    },
  },
];
